import defaultAvatar from '@/public/images/default-avatar.png';
import placeDefaultPhoto from '@/public/images/default-place-photo-better-quality.png';
import defaultEventImage from '@/public/images/event_photo.jpg';
import { Event } from '@/types/event';

export type ImageShape = 'square' | 'rect' | 'default';
export type ImageDefault = 'place' | 'avatar' | 'event' | 'none';

const IMAGE_DEFAULT: { [k in ImageDefault]: any } = {
  avatar: defaultAvatar,
  place: placeDefaultPhoto,
  event: defaultEventImage,
  none: undefined,
};

function getDefaultImage(defaultImage: ImageDefault) {
  if (defaultImage === 'none') return;
  return IMAGE_DEFAULT[defaultImage];
}

export class ImageHelper {
  static getPlaceFilesUrls(
    files?: any[],
    shape: ImageShape = 'rect'
  ): string[] {
    if (!files || files.length == 0) return [];
    return (files
      ?.map((e) => ImageHelper.getDisplayUrl(e, shape))
      .filter((v) => !!v) || []) as string[];
  }

  static getEventCoverUrl(
    event: Event,
    shape: ImageShape = 'rect',
    defaultImage: ImageDefault = 'place'
  ) {
    if (!event?.cover) return getDefaultImage(defaultImage);
    return ImageHelper.getDisplayUrl(event.cover, shape);
  }

  static getDisplayUrl(
    file: any,
    shape: ImageShape = 'default',
    defaultImage: ImageDefault = 'place'
  ): string {
    if (!file?.url) return getDefaultImage(defaultImage);

    switch (shape) {
      case 'square':
        return file['url-square'] || file.urlSquare || file.url;
      case 'rect':
        return file['url-rect'] || file.urlRect || file.url;
      default:
        return file.url;
    }
  }
}
